import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Phone,
  Mail,
  MapPin,
  ArrowRight,
  Menu,
  X,
} from "lucide-react";

import logo1 from "../Assets/Logo1.jpg";
import LogoMaster from "../Assets/Artboard 9@300x.png";
import { productData } from "../Pages/Products";
import konstruksiIcon from "../Assets/Konstruksi.png";
import materialIcon from "../Assets/Material.png";
import alatBeratIcon from "../Assets/alatberat.png";
import perumahanIcon from "../Assets/perumahan.png";
import bricsIcon from "../Assets/Brics.png";

const LandingPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("about");

  useEffect(() => {
    const sections = document.querySelectorAll("section");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      id: 1,
      title: "Konstruksi",
      description:
        "Pengerjaan proyek infrastruktur, jalan, dan pembangunan sipil dengan kualitas terbaik.",
      icon: konstruksiIcon,
    },
    {
      id: 2,
      title: "Material Konstruksi",
      description:
        "Menyediakan pasir, split, batu pondasi, dan berbagai kebutuhan material konstruksi.",
      icon: materialIcon,
    },
    {
      id: 3,
      title: "Sewa Alat Berat",
      description:
        "Penyewaan excavator, bulldozer, vibro, loader, dan berbagai alat berat lainnya.",
      icon: alatBeratIcon,
    },
    {
      id: 4,
      title: "Developer Perumahan",
      description:
        "Membangun kawasan hunian berkualitas dan nyaman untuk masyarakat Indonesia.",
      icon: perumahanIcon,
    },
    {
      id: 5,
      title: "Brics",
      description:
        "Produksi bata ringan dan pagar beton untuk mendukung pembangunan modern.",
      icon: bricsIcon,
    },
  ];

  const milestones = [
    {
      year: "1985",
      title: "Berdirinya Sami Jaya",
    },
    {
      year: "1986",
      title: "Mulai mengerjakan proyek cut & fill dan pengaspalan",
    },
    {
      year: "1997",
      title: "Membangun proyek perumahan pertama",
    },
    {
      year: "2002",
      title: "Membuka crusher batu di Yogyakarta",
    },
    {
      year: "2020",
      title: "Produksi pagar beton",
    },
    {
      year: "2024",
      title: "Produksi bata ringan",
    },
  ];

  // const products = [
  //   {
  //     id: 1,
  //     name: "Pasir",
  //     category: "Material",
  //     image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3",
  //   },
  //   {
  //     id: 2,
  //     name: "Batu Split",
  //     category: "Material",
  //     image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd",
  //   },
  //   {
  //     id: 3,
  //     name: "Excavator",
  //     category: "Alat Berat",
  //     image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5",
  //   },
  //   {
  //     id: 4,
  //     name: "Bulldozer",
  //     category: "Alat Berat",
  //     image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd",
  //   },
    
  // ];
const products = Object.values(productData);
  return (
    <div className="bg-[#f8fafc] overflow-hidden">
      {/* NAVBAR */}
      <nav className="fixed top-0 left-0 w-full z-50 bg-white/90 backdrop-blur border-b border-gray-100">
        <div className="container mx-auto px-6 py-4 flex items-center justify-between">
          {/* LOGO */}
          <div className="flex items-center gap-3">
            <img
              src={logo1}
              alt="Logo"
              className="w-10 h-10 object-contain"
            />

            <h1 className="text-2xl font-bold text-blue-700">
              Samijaya
            </h1>
          </div>

          {/* DESKTOP MENU */}
          <div className="hidden lg:flex items-center gap-8">
            {[
              "about",
              "services",
              "milestones",
              "products",
              "contact",
            ].map((item) => (
              <a
                key={item}
                href={`#${item}`}
                className={`capitalize transition font-medium ${
                  activeSection === item
                    ? "text-blue-600"
                    : "text-gray-600 hover:text-blue-600"
                }`}
              >
                {item}
              </a>
            ))}
          </div>

          {/* MOBILE BUTTON */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden"
          >
            {isOpen ? <X /> : <Menu />}
          </button>
        </div>

        {/* MOBILE MENU */}
        {isOpen && (
          <div className="lg:hidden bg-white border-t">
            <div className="flex flex-col p-6 gap-4">
              {[
                "about",
                "services",
                "milestones",
                "products",
                "contact",
              ].map((item) => (
                <a
                  key={item}
                  href={`#${item}`}
                  className="capitalize text-gray-700"
                >
                  {item}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>

      {/* HERO */}
      <section
        className="relative min-h-screen flex items-center bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 overflow-hidden"
      >
        <div className="container mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center pt-32">
          {/* LEFT */}
          <div className="text-white">
            <p className="uppercase tracking-[5px] text-blue-300 mb-4">
              Sejak 1985
            </p>

            <h1 className="text-5xl lg:text-7xl font-bold leading-tight mb-6">
              Mitra
              <span className="text-yellow-400">
                {" "}Konstruksi{" "}
              </span>
              Kepercayaan Anda
            </h1>

            <p className="text-gray-300 text-lg leading-relaxed mb-8 max-w-xl">
              Sami Jaya bergerak di bidang konstruksi,
              material bangunan, persewaan alat berat,
              dan pengembangan properti dengan pengalaman
              lebih dari 40 tahun.
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="#contact"
                className="bg-yellow-400 hover:bg-yellow-300 text-slate-900 px-8 py-4 rounded-xl font-semibold transition"
              >
                Hubungi Kami
              </a>

              <a
                href="#products"
                className="border border-white/20 hover:bg-white/10 px-8 py-4 rounded-xl transition"
              >
                Lihat Produk
              </a>
            </div>

            {/* STATS */}
            <div className="flex flex-wrap gap-10 mt-14">
              <div>
                <h3 className="text-4xl font-bold">40+</h3>
                <p className="text-gray-400">
                  Tahun Pengalaman
                </p>
              </div>

              <div>
                <h3 className="text-4xl font-bold">100+</h3>
                <p className="text-gray-400">Proyek</p>
              </div>

              <div>
                <h3 className="text-4xl font-bold">24/7</h3>
                <p className="text-gray-400">Support</p>
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div className="flex justify-center">
            <img
              src={LogoMaster}
              alt="Hero"
              className="w-[10000px] object-contain drop-shadow-2xl"
            />
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section id="about" className="py-24">
        <div className="container mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* IMAGE */}
            <div>
              <img
                src="https://images.unsplash.com/photo-1504307651254-35680f356dfd"
                alt="Construction"
                className="rounded-3xl shadow-2xl"
              />
            </div>

            {/* CONTENT */}
            <div>
              <p className="text-blue-600 font-semibold mb-3">
                ABOUT US
              </p>

              <h2 className="text-4xl font-bold text-gray-800 mb-6">
                Membangun Indonesia Bersama Sami Jaya
              </h2>

              <p className="text-gray-600 leading-relaxed mb-6">
                Didirikan pada tahun 1985, Sami Jaya
                telah berkembang menjadi perusahaan yang
                bergerak di bidang konstruksi, material
                bangunan, alat berat, dan pengembangan
                properti.
              </p>

              <p className="text-gray-600 leading-relaxed mb-8">
                Dengan pengalaman lebih dari tiga dekade,
                kami terus berkomitmen memberikan layanan
                berkualitas dan menjadi mitra terpercaya
                dalam pembangunan Indonesia.
              </p>

              <a
                href="#services"
                className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl transition"
              >
                Layanan Kami
                <ArrowRight size={18} />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section
        id="services"
        className="py-24 bg-white"
      >
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-blue-600 font-semibold mb-3">
              SERVICES
            </p>

            <h2 className="text-4xl font-bold text-gray-800">
              Layanan Kami
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <div
                key={service.id}
                className="bg-[#f8fafc] p-8 rounded-3xl shadow-sm hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
              >
                <img
                  src={service.icon}
                  alt={service.title}
                  className="w-16 h-16 mb-6"
                />

                <h3 className="text-2xl font-semibold text-gray-800 mb-4">
                  {service.title}
                </h3>

                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* MILESTONES */}
      <section
        id="milestones"
        className="py-24"
      >
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-blue-600 font-semibold mb-3">
              JOURNEY
            </p>

            <h2 className="text-4xl font-bold text-gray-800">
              Perjalanan Kami
            </h2>
          </div>

          <div className="space-y-8 max-w-4xl mx-auto">
            {milestones.map((item, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-3xl shadow-md flex items-center gap-6"
              >
                <div className="min-w-[80px] h-[80px] rounded-2xl bg-blue-600 text-white flex items-center justify-center text-xl font-bold">
                  {item.year}
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-gray-800">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PRODUCTS */}
      <section
        id="products"
        className="py-24 bg-white"
      >
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-blue-600 font-semibold mb-3">
              PRODUCTS
            </p>

            <h2 className="text-4xl font-bold text-gray-800">
              Produk Kami
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {products.map((product) => (
              <div
                key={product.id}
                className="group overflow-hidden rounded-3xl bg-white shadow-md hover:shadow-2xl transition"
              >
                <div className="overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="h-64 w-full object-cover group-hover:scale-110 transition duration-500"
                  />
                </div>

                <div className="p-6">
                  <p className="text-blue-600 mb-2">
                    {product.category}
                  </p>

                  <h3 className="text-2xl font-semibold text-gray-800 mb-4">
                    {product.name}
                  </h3>

                  <Link
                    to={`/DetailPage/${product.id}`}
                    className="inline-flex items-center gap-2 text-blue-600 font-medium hover:gap-3 transition-all"
                  >
                    Detail
                    <ArrowRight size={18} />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section
        id="contact"
        className="py-24"
      >
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-blue-600 font-semibold mb-3">
              CONTACT
            </p>

            <h2 className="text-4xl font-bold text-gray-800">
              Hubungi Kami
            </h2>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            {/* LEFT */}
            <div className="bg-white rounded-3xl shadow-xl p-10">
              <div className="space-y-8">
                <div className="flex gap-4">
                  <Phone className="text-blue-600" />
                  <div>
                    <h3 className="font-semibold text-lg">
                      WhatsApp
                    </h3>
                    <p className="text-gray-600">
                      +62 812-3456-789
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <Mail className="text-blue-600" />
                  <div>
                    <h3 className="font-semibold text-lg">
                      Email
                    </h3>
                    <p className="text-gray-600">
                      sjkontraktor@gmail.com
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <MapPin className="text-blue-600" />
                  <div>
                    <h3 className="font-semibold text-lg">
                      Lokasi
                    </h3>
                    <p className="text-gray-600">
                      Mojosongo, Surakarta, Jawa Tengah
                    </p>
                  </div>
                </div>

                <a
                  href="https://wa.me/628123456789"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block mt-4 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-xl font-semibold transition"
                >
                  Chat WhatsApp
                </a>
              </div>
            </div>

            {/* RIGHT */}
            <div className="rounded-3xl overflow-hidden shadow-xl">
              <iframe
                        title="Sami Jaya Location"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15821.117712081874!2d110.81998588715823!3d-7.544475800000008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e7a17001c81a175%3A0xb2c1cec59a2a3f48!2sCV.%20Sami%20Jaya!5e0!3m2!1sen!2sid!4v1758298731689!5m2!1sen!2sid"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                      ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-slate-900 text-white py-16">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-12">
            {/* LOGO */}
            <div>
              <div className="flex items-center gap-3 mb-6">
                <img
                  src={logo1}
                  alt="logo"
                  className="w-12 h-12"
                />

                <h2 className="text-2xl font-bold">
                  Samijaya
                </h2>
              </div>

              <p className="text-gray-400 leading-relaxed">
                Mitra konstruksi terpercaya sejak 1985
                dalam bidang material, alat berat,
                konstruksi, dan properti.
              </p>
            </div>

            {/* MENU */}
            <div>
              <h3 className="text-xl font-semibold mb-6">
                Navigasi
              </h3>

              <ul className="space-y-3 text-gray-400">
                <li><a href="#about">About</a></li>
                <li><a href="#services">Services</a></li>
                <li><a href="#products">Products</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>

            {/* SERVICES */}
            <div>
              <h3 className="text-xl font-semibold mb-6">
                Layanan
              </h3>

              <ul className="space-y-3 text-gray-400">
                <li>Cut & Fill</li>
                <li>Sewa Alat Berat</li>
                <li>Material Konstruksi</li>
                <li>Developer</li>
              </ul>
            </div>

            {/* CONTACT */}
            <div>
              <h3 className="text-xl font-semibold mb-6">
                Kontak
              </h3>

              <ul className="space-y-4 text-gray-400">
                <li>+62 812-3456-789</li>
                <li>sjkontraktor@gmail.com</li>
                <li>Surakarta, Jawa Tengah</li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 mt-16 pt-8 text-center text-gray-500">
            © {new Date().getFullYear()} PT. Samijaya.
            All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;